
import * as React from "react"
import OutlinedInput, { type OutlinedInputProps } from "@mui/material/OutlinedInput"

import { cn } from "@/lib/utils"

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, rows, ...props }, ref) => {
    const muiInputProps = props as Omit<
      OutlinedInputProps,
      "className" | "fullWidth" | "inputRef" | "sx" | "multiline" | "minRows" | "inputProps"
    >

    return (
      <OutlinedInput
        fullWidth
        multiline
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground",
          "outline-none transition-colors focus-within:!border-ring",
          className
        )}
        inputRef={ref}
        minRows={rows ?? 3}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
          "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
          "& .MuiOutlinedInput-input": {
            padding: "8px 12px",
            outline: "none",
          },
          "& textarea:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px hsl(var(--background)) inset",
            WebkitTextFillColor: "hsl(var(--foreground))",
            caretColor: "hsl(var(--foreground))",
            transition: "background-color 5000s ease-in-out 0s",
          },
          "& textarea:-webkit-autofill:hover, & textarea:-webkit-autofill:focus, & textarea:-webkit-autofill:active":
            {
              WebkitBoxShadow: "0 0 0 1000px hsl(var(--background)) inset",
              WebkitTextFillColor: "hsl(var(--foreground))",
            },
          "&.Mui-disabled": {
            opacity: 0.5,
          },
        }}
        {...muiInputProps}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
